// @generated
// AUTO-GENERATED by scripts/generate-fhir-terminologies.ts. Do not edit.
// Run: npm run generate:terminologies
// Source: apps/ig/input/resources/value-sets/alopex-races.json
export const URL = 'http://alopexcare.com/fhir/ValueSet/alopex-races';
export const concepts = [
    { code: '1002-5', display: 'American Indian or Alaska Native', displayUi: 'American Indian or Alaska Native', system: 'urn:oid:2.16.840.1.113883.6.238' },
    { code: '2028-9', display: 'Asian', displayUi: 'Asian', system: 'urn:oid:2.16.840.1.113883.6.238' },
    { code: '2054-5', display: 'Black or African American', displayUi: 'Black or African American', system: 'urn:oid:2.16.840.1.113883.6.238' },
    { code: '2076-8', display: 'Native Hawaiian or Other Pacific Islander', displayUi: 'Native Hawaiian or Other Pacific Islander', system: 'urn:oid:2.16.840.1.113883.6.238' },
    { code: '2106-3', display: 'White', displayUi: 'White', system: 'urn:oid:2.16.840.1.113883.6.238' },
];
export function isValidCode(value) {
    return concepts.some((c) => c.code === value);
}
/** Returns the UI display (designation override if present, else canonical display). */
export function getDisplay(code) {
    return concepts.find((c) => c.code === code)?.displayUi ?? '';
}
/**
 * Build a FHIR Coding with the canonical display (NOT displayUi) to preserve
 * server-side terminology-binding validity. Use getDisplay() for UI rendering.
 */
export function toCoding(code) {
    const concept = concepts.find((c) => c.code === code);
    return { system: concept?.system ?? '', code, display: concept?.display ?? '' };
}
